<div #popup class="columns-popup" id="popup" [class.active]="showPopup()">
  <!-- Header -->
  <div class="popup-header">
    <span>{{ 'GENERAL.COLUMNS' | translate }}</span>
    <button
      mat-icon-button
      class="popup-close-button"
      (click)="closePopup()"
      [attr.aria-label]="'GENERAL.CLOSE' | translate"
    >
      <mat-icon>close</mat-icon>
    </button>
  </div>
  <!-- Content -->
  <div class="inner">
    <div class="content" #popupcontent></div>
  </div>
  <!-- Footer -->
  <div class="popup-footer">
    <button class="reset" [disabled]="!canReset()" (click)="onReset()">
      {{ 'GENERAL.RESET' | translate | uppercase }}
    </button>
    <button class="save" [disabled]="!isDirty()" (click)="onSave()">
      {{ 'GENERAL.SAVE' | translate | uppercase }}
    </button>
  </div>
</div>
